import React from 'react';

import { connect } from  'react-redux';

import { Redirect, Link } from 'react-router-dom';

import {api,API_URL} from '../../actions/_request';
import swal from 'sweetalert2';
//libs
import Select , {Async}  from 'react-select';
import moment from 'moment';

import * as actions from '../../actions/balancegeneral';
import ReactTable from "react-table";
import "react-table/react-table.css";
import {
    Card, CardBlock,
    Button, ButtonGroup,
    InputGroup, InputGroupAddon, InputGroupButton,InputGroupText,
    Input,
    Badge,
    Row,
    CardTitle
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink, CardText, Col } from 'reactstrap';
import classnames from 'classnames';
import Fasearch from 'react-icons/lib/fa/search';
import FAprint from 'react-icons/lib/fa/print';
import IconEdit from 'react-icons/lib/md/edit';
import IconCheckCircle from 'react-icons/lib/md/check-circle';
import FaFilePdf from 'react-icons/lib/fa/file-pdf-o';
import FaFileExcel from 'react-icons/lib/fa/file-excel-o';

const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };

const meses = [
	{label : 'Enero' , value : 1},
	{label : 'Febrero', value : 2},
	{label : 'Marzo', value : 3},
	{label : 'Abril' , value: 4},
	{label : 'Mayo' , value: 5},
	{label : 'Junio' , value: 6},
	{label : 'Julio' , value: 7},
	{label : 'Agosto' , value: 8},
	{label : 'Septiembre' , value: 9},
	{label : 'Octubre' , value: 10},
	{label : 'Noviembre' , value: 11},
	{label : 'Diciembre' , value: 12},
];

class BalanceGeneral extends React.Component{

	constructor(props){
		super(props)

		this.state = {
			reporte :[],
			 activeTab: '1',
			 buscar:0,
			 data:[],
			 loading: false,
			 mes : 1,
        	ano:0,
        	anos:[],
		}
		
	    this.search = this.search.bind(this);
		this.guardar = this.guardar.bind(this);
		this.toggle_tab= this.toggle_tab.bind(this);
		this.handleSelectChange= this.handleSelectChange.bind(this);
		this.pagar= this.pagar.bind(this);

	}
	pagar(evt, usuario_id ,total,nombre) {

        let {mes,ano} = this.state;
        let self = this;
        /*el indice 12  pertenece al modulo Pago comision(13) solo se toma en cuenta  en indice menu  */
        // console.log('permiso para pagar comision--->',this.props.auth.permisos[12].menu);
        if(parseInt(this.props.auth.permisos[12].menu)==0){
            swal("Advertencia!", "No Tienes el Permiso para Esta Accion!", "error");
            return
        }

       
        let pago={
        	'usuario_id':usuario_id,
        	'total' : total,
        	'mes': mes,
        	'ano' : ano,
        };
        // console.log('Pago----->',pago);

        swal.queue([{
        title: 'Estas seguro?',
        text: "De Pagar la Comision de : "+nombre,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: (opcion) => {
        	// console.log('opcion---->',opcion)
          return api().post(`/pagar_comision_produccion`,pago)
			        .then(function(response)
			        {                  
			            if(response.status === 200)
			            { 
			            	 self.setState({     
					                loading: true,        
					        });
			             	swal("Bien hecho!", "La Comision Fue Pagada Con Exito!", "success");                    
			            }else{

			            }

			            api().get(`/buscar_reporte_general_comisiones/${mes}/${ano}`)
			            .then(function(response)
			            {                  
			                if(response.status === 200)
			                { 
			                       self.setState({
							        	reporte : response.data,
							        	buscar:1,
							        	loading: false,
							        });
			                }
			            });

			        });
        }
      }]);
















       
		    


        
    }
	handleSelectChange(select, name) {

        
        const value = select === null ? null : select.value;
        this.setState({
           
             
                [name]: value,
                buscar:0,
                reporte:[],
        
        });
    }
	search(){
		let self = this;
			this.setState({     
	                loading: true,        
	        });
		    api().get(`/buscar_reporte_general_comisiones/${this.state.mes}/${this.state.ano}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                
                     
                       
                       self.setState({
				        	reporte : response.data,
				        	buscar:1,
				        	loading: false,

				        });
                }

            });
	}
	toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }




	guardar(){
   // console.log('entro');
   let reporte = this.state.reporte;
   // console.log('reporte--->',reporte);
   let self = this;
		if(reporte.id==null){

			this.props.save(reporte, (response) => {
				
							
					self.setState({reporte : response});
					// console.log('reporte regresado--->',response);

					swal("Bien hecho!", "El reporte fue Registrado  con éxito!", "success");
				

			});

		}else{
			this.props.update(reporte, (response) => {
					self.setState({reporte : response});
					// console.log('reporte regresado--->',response);
					swal("Bien hecho!", "El reporte fue actualizado  con éxito!", "success");
			});

		}

	}
	 componentDidMount(){
	  let self = this;

	 	var fecha = new Date();
        var ano = fecha.getFullYear();
        let anos=[];

        for (var i = 5 ; i >= 0; i--) {
        	anos.unshift({label:(ano-i),value:(ano-i)});
        }



        this.setState({
        	mes : parseInt(fecha.getMonth())+1,
        	ano:ano,
        	anos:anos,
        });
       
        
        
    }

    excel(mes,ano) {
          let self = this;
         self.setState({     
                loading: true,        
        });
        api().post(`/documento_comisiones_general/${mes}/${ano}/1`, []).then(function(response) {

                if(response.status === 200) {
                  var a = document.createElement("a");
                  a.href = response.data.file; 
                  a.download = response.data.name;
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                }
                else{
                }
                 self.setState({     
                                    loading: false,        
                            });

              })
              .catch(function(error) {
               
              });
      }






	render(){

		let {reporte,loading,buscar,mes,ano} = this.state;
		// console.log("state--->",this.state);
        // console.log('user',this.props.auth);
		return(
		<Card className="px-3">
			<div className="mb-2"></div>
			<Nav tabs>
				<NavItem>
					<NavLink className={classnames({ active: this.state.activeTab === '1' })}	onClick={() => { this.toggle_tab('1'); }}	>
						Reporte General De Comisiones
					</NavLink>
				</NavItem>
			</Nav>
			<TabContent activeTab={this.state.activeTab}>
				<TabPane tabId="1">
				 <div className="row">
				 <div className="col-md-1"> 
                    <div className="form-group">
                    </div>
                 </div>
				<div className="col-md-4"> 
                    <div className="form-group">
                        <label className>Mes:</label>
                        <Select
                            placeholder=""
                            type="text"
                            name="mes"
                            options={meses}
                            value={parseInt(this.state.mes) || 1}
                           onChange={ (select) => { this.handleSelectChange(select, 'mes') } }
                            clearable={false}

                        />
                    </div>
                </div>
                <div className="col-md-4"> 
                    <div className="form-group">
                        <label className>Año:</label>
                        <Select
                            placeholder=""
                            type="text"
                            name="ano"
                            options={this.state.anos}
                            value={parseInt(this.state.ano) || 1}
                           onChange={ (select) => { this.handleSelectChange(select, 'ano') } }
                            clearable={false}

                        />
                    </div>
                </div>
                <div className="col-md-3"> 
                    <div className="form-group">
                    					<label><br/></label><br/>
                    					{
                    						!loading &&
                    						<Button color='success' onClick={this.search}> <Fasearch size='1.2em'/> </Button>
                    					}
										
										{'  '}
										{(!loading&&buscar==1)&&
											<Button color='secondary' onClick={ (select) => { window.open(`${API_URL}/documento_comisiones_general/${mes}/${ano}/0`); } }> <FaFilePdf color='red' size='1.3em'/> </Button>
                                        }{'  '}{(!loading&&buscar==1)&&
                                            <Button color='secondary' onClick={ (select) => { this.excel(mes,ano) } }> <FaFileExcel color='green' size='1.3em'/> </Button>
										}
										
                    </div>
                 </div>
                </div>

					<Row>
						<Col sm="12" >
		
							<div className="row ">
							<div className="col-12">

								<Card>
                        <CardBlock>
                        <div className="text-right">
                               
                            </div>
                            <ReactTable
                              className = "-striped -highlight"
                              columns   = {[
                               
                                {Header: 'Nombre', accessor: 'nombre',minWidth:500 , style: { 'textAlign': 'center'} },
                                {Header: 'Meta', accessor: 'meta',maxWidth:150,minWidth:150, filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                {Header: 'Produccion Total', accessor: 'produccion',maxWidth:150,minWidth:150, filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                {Header: 'Comision Excedente', accessor: 'comision_excedente',maxWidth:150,minWidth:150, filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                {Header: 'Bono', accessor: 'bono',maxWidth:150,minWidth:150, filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                {Header: 'Comision', accessor: 'comision',maxWidth:150,minWidth:150, filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                {Header: 'Total', accessor: 'total',maxWidth:150,minWidth:150, filterable: false, sortable: false, style: { 'textAlign': 'center'}},

                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:150,
                                    minWidth:150,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                                {
                                                parseInt(	row.original.pagado)===0?<Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.pagar(evt, row.original.usuario_id,row.original.total_numero,row.original.nombre )}>
                                                    <IconCheckCircle />
                                                </Button>:"Pagado"
                                                }{' '}
                                                 
                                            </div>
                                        )
                                    }
                                }
                              
                              ]}                         

                              data={this.state.reporte}
                              filterable 
		                      defaultPageSize={10} 
		                      defaultFilterMethod={filterCaseInsensitive}
		                      loading={loading} // Display the loading overlay when we need it
                              
                             
                            />
                        </CardBlock>
                    </Card>
                    </div>





							</div>
							<br/><br/>
							<div className="row">
								<div className="col-12 text-right">
								
								</div>
							</div>
							<br/><br/>
						</Col>
					</Row>
				</TabPane>
			</TabContent>
		</Card>
		)
	}

}

function mapStateToProps(state, ownProps) {
    return {
        balancegeneral : state.balancegeneral,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(BalanceGeneral)


// WEBPACK FOOTER //
// ./src/views/reportes/reporteComicionesGeneral.js